export const primary = '#545871';
export const primaryAlt = '#9597A6';

export const secondary = '#B8817D';
export const secondaryAlt = '#EBD0CE';

export const tertiary = '#E6DBDA';
export const tertiaryAlt = '#F7ECEB';

export const light = '#DADBE6';
export const lightAlt = '#F0F1F7';

export const white = '#fff';
export const black = '#222';

export const error = 'red';
export const success = 'green';
